/* JungleSocks · Performance — carrito lateral
   1. Añadir en un toque desde la venta cruzada (por talla) y desde la caja regalo, y re-renderizar el carrito.
      Botones [data-perf-add="variantId"]; propiedades opcionales en data-perf-props (JSON).
   2. Animar la barra de envío gratis desde el valor anterior tras cada re-render. */
(function () {
  if (window.__perfCartDrawer) return;
  window.__perfCartDrawer = true;

  var lastProgress = null;

  function animateShipping() {
    var fill = document.querySelector('#CartDrawer [data-perf-ship-fill]');
    if (!fill) return;
    var target = parseFloat(fill.getAttribute('data-p')) || 0;
    if (fill.__perfDone) return;
    fill.__perfDone = true;
    if (lastProgress !== null && lastProgress !== target) {
      fill.style.transition = 'none';
      fill.style.width = lastProgress + '%';
      void fill.offsetWidth;
      fill.style.transition = '';
      requestAnimationFrame(function () {
        fill.style.width = target + '%';
      });
    }
    lastProgress = target;
  }

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-perf-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var section = btn.closest('.perf-upsell, .perf-giftbox');
    var errorEl = section && section.querySelector('.perf-upsell__error, .perf-giftbox__error');
    var labels = section ? section.dataset : {};
    var original = btn.innerHTML;

    var item = { id: Number(btn.dataset.perfAdd), quantity: 1 };
    if (btn.dataset.perfProps) {
      try {
        item.properties = JSON.parse(btn.dataset.perfProps);
      } catch (e) {}
    }

    if (errorEl) errorEl.hidden = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = labels.addingLabel || '…';

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (state) {
        if (state.status || !state.sections) throw new Error(state.description || 'error');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && document.getElementById('main-cart-items')) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'perf-cart-upsell', cartData: state });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.innerHTML = original;
        if (errorEl) {
          errorEl.textContent = labels.errorLabel || 'Error';
          errorEl.hidden = false;
        }
      });
  });

  function observe() {
    var root = document.getElementById('CartDrawer');
    if (!root) return;
    animateShipping();
    new MutationObserver(animateShipping).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();